import type { TourStepData } from './types';

export const knowledgeExplorerTourSteps: TourStepData[] = [
  {
    target: '[data-tour="knowledge-explorer-header"]',
    title: 'Knowledge Explorer',
    content:
      'Le Knowledge Explorer (Explorateur de connaissances) permet de consulter et valider la base de connaissances (Knowledge Base) utilisee par l\'IA pour le RAG.',
    placement: 'bottom',
    glossaryTerm: 'knowledge-explorer',
  },
  {
    target: '.grid.grid-cols-1.sm\\:grid-cols-2.lg\\:grid-cols-4',
    title: 'Statistiques des briques',
    content:
      'Visualisez le total des briques de connaissances, leur statut de verification et le nombre d\'usages par l\'IA.',
    placement: 'bottom',
  },
  {
    target: '.fc-card',
    title: 'Filtres et recherche',
    content:
      'Filtrez les briques par categorie, source, persona ou statut de verification pour trouver rapidement l\'information.',
    placement: 'bottom',
  },
];
